module.exports = __webpack_public_path__ + "files/mcsd_sharepoint_applications.378e099c.pdf";